<div>
  <div class="menu">
    <ichannel-link [name]="'STATUS'" [link]="'status'"></ichannel-link>
    <ichannel-link [name]="'OUTPUTS'" [link]="'outputs'"></ichannel-link>
    <ichannel-link [name]="'ALERTS'" [link]="'alerts'"></ichannel-link>
    <ichannel-link [name]="'EVENT LOGS'" [link]="'event-logs'"></ichannel-link>
  </div>
  <router-outlet></router-outlet>
</div>
